export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const d = new Date(String(dateStr).slice(0, 10) + "T00:00:00");
  if (isNaN(d)) return null;
  const now = new Date(); now.setHours(0, 0, 0, 0);
  return Math.round((d - now) / 86400000);
}

export function DueChip({ date, testid }) {
  const n = daysUntil(date);
  if (n === null) return null;
  let cls = "bg-emerald-50 text-emerald-700", label = `in ${n}d`;
  if (n < 0) { cls = "bg-red-50 text-red-700"; label = `${Math.abs(n)}d overdue`; }
  else if (n === 0) { cls = "bg-amber-100 text-amber-800"; label = "due today"; }
  else if (n <= 7) { cls = "bg-amber-50 text-amber-700"; label = `in ${n}d`; }
  else if (n <= 30) { cls = "bg-gray-100 text-gray-600"; label = `in ${n}d`; }
  return <span data-testid={testid} className={`ml-2 rounded-sm px-1.5 py-0.5 text-[10px] font-medium ${cls}`}>{label}</span>;
}
